__webpack_require__.p = "/mailbox-upload/onboarding/";